import MUISwitch, { SwitchProps } from '@mui/material/Switch';

const Switch = (props: SwitchProps) => {
  return <MUISwitch {...props} />;
};

export default Switch;
